import { render, staticRenderFns } from "./ConsensiEditComponent.vue?vue&type=template&id=d0508d20&scoped=true"
import script from "./ConsensiEditComponent.vue?vue&type=script&lang=js"
export * from "./ConsensiEditComponent.vue?vue&type=script&lang=js"
import style0 from "./ConsensiEditComponent.vue?vue&type=style&index=0&id=d0508d20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0508d20",
  null
  
)

export default component.exports